/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cv_Check_Privacy_ConsentInputs */

const en_cv_check_privacy_consent = /** @type {(inputs: Cv_Check_Privacy_ConsentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`By uploading, I agree to the transmission of my resume to our AI service providers. I have read the `)
};

const de_cv_check_privacy_consent = /** @type {(inputs: Cv_Check_Privacy_ConsentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mit dem Hochladen stimme ich der Übermittlung meines Lebenslaufs an unsere KI-Dienstleister zu. Die `)
};

/**
* | output |
* | --- |
* | "By uploading, I agree to the transmission of my resume to our AI service providers. I have read the" |
*
* @param {Cv_Check_Privacy_ConsentInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const cv_check_privacy_consent = /** @type {((inputs?: Cv_Check_Privacy_ConsentInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cv_Check_Privacy_ConsentInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_cv_check_privacy_consent(inputs)
	return en_cv_check_privacy_consent(inputs)
});